import config from 'config'
import { CopyLinkButton } from 'components'
import { track } from 'utils/analytics-tracker'

import { ShareBubbles } from 'components/ShareBubbles'
import styles from './ShareLink.module.scss'
import classNames from 'classnames'

export const ShareLink = ({
  fund,
  fundHandle,
  setFundHandle,
  shareSource,
  updateGiftingPage,
  className,
  shareLinkProps,
  shareBubblesProps
}: {
  fund: {
    fundName: string
    uuid: string
  }
  fundHandle: string
  setFundHandle?: (arg0: string) => void
  shareSource: 'gifting page' | 'fund page' | 'fund settings'
  updateGiftingPage?: any
  className?: string
  shareLinkProps?: {
    linkEmojiCls?: string
    copyLinkContainerCls?: string
  }
  shareBubblesProps?: {
    headerClassName?: string
    header?: string
    noLabel?: boolean
    bubbleCls?: string
  }
}) => {
 
  const { fundName, uuid } = fund
  const handleLink = `${config.BACKEND_ROOT_URL}/${fundHandle}`

  return (
    <div className={className}>
      <p className={classNames(styles.linkEmoji, shareLinkProps?.linkEmojiCls)}>&#128279;</p>
      <div className={classNames(styles.copyLinkContainer, shareLinkProps?.copyLinkContainerCls, {
        [styles.noEditHandle]: !setFundHandle || !updateGiftingPage
      })}>
        <span className={styles.handle}>
          <span>{config.BACKEND_ROOT_URL.split('://')[1]}/</span>
          <span>{fundHandle}</span>
        </span>
        <div className={styles.ctasContainer}>
          <CopyLinkButton
            label="Copy"
            link={handleLink}
            track={() => track('ShareCopy', { fundUuid: uuid, shareSource })}
          />
        </div>
      </div>
      <ShareBubbles
        event="FundLinkShare"
        shareSource={shareSource}
        headerClassName={shareBubblesProps?.headerClassName}
        header={shareBubblesProps?.header}
        shareLink={`${config.BACKEND_ROOT_URL}/${fundHandle}`}
        text={"We're saving for college together with Backer, and we'd love to have you on our team ❤️"}
        subject={`We're saving together for ${fundName}`}
        eventPayload={{ fundUuid: uuid }}
        bubbleCls={classNames(styles.bubble, shareBubblesProps?.bubbleCls)}
        noLabel={shareBubblesProps?.noLabel}
        iconColor="#141414"
        mailProps={{
          iconWidth: 20,
        }}
        textProps={{
          iconWidth: 20,
          iconStyle: { top: 2, position: 'relative'}
        }}
        kebabMenuProps={{
          iconWidth: 15,
        }}
      />
    </div>
  )
}